import { render, staticRenderFns } from "./AgroFooter.vue?vue&type=template&id=b6674644&"
import script from "./AgroFooter.vue?vue&type=script&lang=ts&"
export * from "./AgroFooter.vue?vue&type=script&lang=ts&"
import style0 from "./agro-footer.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports